import { JwtService } from './jwt.service';

import { of as observableOf, Observable, Subject, BehaviorSubject } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { AppConstants } from '../../utils/appConstants.class';
import { LoadSpinnerService } from './load-spinner.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isLoggedIn$: Subject<boolean> = new BehaviorSubject<boolean>(this.isLoggedIn());

  constructor(private http: HttpClient, private jwtService: JwtService, private loader: LoadSpinnerService) {}

  login(formModel: any): Observable<any> {
    this.loader.showSpinner();
    return this.http
      .post(`${environment.auth_url}/login`, formModel, {
        observe: 'response',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With'
        }
      })
      .pipe(
        map((response: any) => {
          this.jwtService.saveToken(response.body.AuthTicket);
          window['isLogged'] = 'True';
          this.isLoggedIn$.next(true);
          this._updateBrowser();
          this.loader.hideSpinner();
          return response;
        }),
        catchError((err) => {
          this.loader.hideSpinner();
          return observableOf(err);
        })
      );
  }

  logout(url?) {
    return this.http.post(`${environment.auth_url}/logout`, { logout: true }).pipe(
      map((response: any) => {
        localStorage.removeItem(AppConstants.CURRENT_USER);
        localStorage.removeItem(AppConstants.CURRENT_LANGUAGE);
        window['isLogged'] = 'False';
        this.isLoggedIn$.next(false);
        if (url) {
          window.location.href = `${location.origin}/${url}`;
        } else {
          window.location.reload();
        }
        sessionStorage.clear();
      })
    );
  }

  editPassword(data: any) {
    return this.http.post(`${environment.auth_url}/editpassword`, data).pipe(
      map((response: any) => {
        this.logout('inspectionbrowser').subscribe();
        return response;
      }),
      catchError((err) => {
        return observableOf(err);
      })
    );
  }

  isLoggedIn() {
    // we will use this when we haven't a conenction and we will use the app on offline
    // (this.apiService.isConnection && this.jwtService.getToken())
    return window['isLogged'] === 'True';
  }

  private _updateBrowser() {
    this.http.get('/inspectionbrowser', { responseType: 'text' }).subscribe();
  }
}
